module.exports = __webpack_public_path__ + "img/right2.1497e352.png";